import { render, staticRenderFns } from "./indexCanpin.vue?vue&type=template&id=8a08e4be&scoped=true"
import script from "./indexCanpin.vue?vue&type=script&lang=js"
export * from "./indexCanpin.vue?vue&type=script&lang=js"
import style1 from "./indexCanpin.vue?vue&type=style&index=1&id=8a08e4be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a08e4be",
  null
  
)

export default component.exports